import React, { FC } from 'react';
import { MoaiLogoStyled } from '../../theme/style';
import { FooterStyled, LogoContainer } from './styled';

const Footer: FC = () => (<FooterStyled><LogoContainer>Powered by<MoaiLogoStyled /></LogoContainer></FooterStyled>);

export default Footer;
